<div class="d-flex flex-column gap-4">
  <div class="d-flex flex-column gap-3">
    <span class="changes-title" i18n>Personal Details</span>
    <div class="changes-container">
      <app-submission-details-field-changes
        *ngIf="!personalPreviousNotApplicable; else previousNotApplicable"
        [changeType]="SubmissionDetailsFieldChangeTypeEnum.Previous"
        [detailsChanges]="personalPrevious" />

      <app-submission-details-field-changes
        *ngIf="!personalNewNotApplicable; else newNotApplicable"
        [changeType]="SubmissionDetailsFieldChangeTypeEnum.New"
        [detailsChanges]="personalNew" />
    </div>
  </div>
  <div class="d-flex flex-column gap-3">
    <span class="changes-title" i18n>Contact Information</span>
    <div class="changes-container">
      <app-submission-details-field-changes
        *ngIf="!contactPreviousNotApplicable; else previousNotApplicable"
        [changeType]="SubmissionDetailsFieldChangeTypeEnum.Previous"
        [detailsChanges]="contactPrevious" />

      <app-submission-details-field-changes
        *ngIf="!contactNewNotApplicable; else newNotApplicable"
        [changeType]="SubmissionDetailsFieldChangeTypeEnum.New"
        [detailsChanges]="contactNew" />
    </div>
  </div>
</div>

<ng-template #previousNotApplicable>
  <div class="changes-card">
    <span class="changes-title" i18n>Previous</span>
    <span class="not-applicable" i18n>Not Applicable</span>
  </div>
</ng-template>

<ng-template #newNotApplicable>
  <div class="changes-card">
    <span class="changes-title" i18n>New</span>
    <span class="not-applicable" i18n>Not Applicable</span>
  </div>
</ng-template>
